import { BaseError } from './base.js';

class AssertionError extends BaseError {
    constructor(message) {
        super(message || "Assertion failed", {
            name: "AssertionError",
        });
    }
}

export { AssertionError };
//# sourceMappingURL=assert.js.map
